export default __webpack_public_path__ + "static/media/bookTwo@2x.351ea047.png";